export default {
  metadata: {
    version: '1.0.0',
    id: 'bottom-navigation-1.0.0',
    name: 'JDSBottomNavigation'
  },
  hierarchy: {
    container: ['jds_bottom_navigation_item']
  },
  base: {
    container: {
      width: '{b_0}',
      'flex-direction': '{b_1}',
      'justify-content': '{b_2}',
      'align-items': '{b_3}',
      'background-color': '{b_4}',
      'padding-left': '{b_5}',
      'padding-top': '{b_6}',
      'padding-right': '{b_7}',
      'padding-bottom': '{b_8}',
      gap: '{b_9}',
      'box-shadow': {
        x: 0,
        y: -1,
        blur: 0,
        spread: 0,
        color: '{b_10}'
      }
    },
    jds_bottom_navigation_item: {
      flex: 1
    }
  },
  variant: {
    multiLine: {
      true: {
        jds_bottom_navigation_item: {
          multiLine: true
        }
      },
      false: {
        jds_bottom_navigation_item: {
          multiLine: false
        }
      }
    }
  },
  combination: [{}],
  combination_config: [[]],
  api: {
    config: {
      multiLine: {
        values: [false, true]
      }
    },
    data: {
      container: {
        value: {
          type: 'list',
          name: 'items',
          object: {
            icon: 'icon',
            label: 'string',
            disabled: 'boolean'
          },
          doc_description: 'It shows list of items.'
        }
      },
      jds_bottom_navigation_item: {
        selectedIndex: {
          type: 'number',
          name: 'activeIndex',
          doc_description: 'It can be used to change the current active index.'
        },
        icon: {
          type: 'icon',
          name: 'items.icon'
        },
        label: {
          type: 'string',
          name: 'items.label'
        },
        disabled: {
          type: 'boolean',
          name: 'items.disabled'
        },
        linkProps: {
          type: 'object',
          name: 'items.linkProps'
        },
        showLabel: {
          type: 'boolean',
          name: 'showLabel',
          doc_description:
            'Shows label below icon if true,by default it is false.'
        }
      }
    },
    events: {
      jds_bottom_navigation_item: {
        onClick: 'onChange'
      }
    },
    a11y: {
      container: {
        properties: {
          role: {
            value: 'tablist'
          }
        },
        name: 'items',
        repeating: {
          ariaLabel: 'navAriaLabel',
          ariaDescribedby: {
            name: 'navAriaDescribedby',
            platform: 'web,ios'
          }
        }
      },
      jds_bottom_navigation_item: {
        properties: {
          ariaLabel: 'items.navAriaLabel',
          ariaDescribedby: 'items.navAriaDescribedby'
        }
      }
    }
  }
};
